module.exports = __webpack_public_path__ + "img/integrated-wallet.ee62fc35.png";